export class Tutor {

    tutorId : number;
    dni     : string;
    name    : string;
    surname : string;
    mail    : string;
    phone1  : string;
    phone2  : string;
    password: string;

}
